import { columnData, sparkLineData } from './scorecard-finance-data';
import _bundle from '../../../core/core--bundles';

// Scorecard Charts
// =============================================================================
function initChart(chart, chartData, chartColumns, chartMetrics, format) {
    chart.kendoChart({
        title: {
            text: '',
            visible: false
        },
        legend: {
            position: 'bottom',
            visible: false
        },
        chartArea: {
            background: '',
            height: 240
        },
        seriesDefaults: {
            type: 'line',
            style: 'smooth',
            markers: {
                visible: true,
                size: 5
            }
        },
        series: [
            {
                name: '',
                data: chartData,
                color: 'rgba(89,93,110, 0.5)'
            }
        ],
        valueAxis: {
            majorGridLines: {
                color: 'rgba(89,93,110, 0.2)',
                type: 'dashDot',
                visible: true,
                step: 2
            },
            plotBands: [
                {
                    from: chartMetrics.greenLow,
                    to: chartMetrics.greenHigh,
                    color: 'rgba(29,201,183, 0.2)'
                },
                {
                    from: chartMetrics.yellowLow,
                    to: chartMetrics.yellowHigh,
                    color: 'rgba(220,156,20, 0.2)'
                },
                {
                    from: chartMetrics.redLow,
                    to: chartMetrics.redHigh,
                    color: 'rgba(231,96,123, 0.2)'
                }
            ],
            labels: {
                format,
                color: '#595d6e'
            },
            line: {
                visible: false
            }
        },
        categoryAxis: {
            categories: chartColumns,
            majorGridLines: {
                visible: true,
                color: 'rgba(89,93,110, 0.1)'
            },
            labels: {
                rotation: 'auto',
                color: '#595d6e'
            },
            line: {
                visible: false
            }
        },
        tooltip: {
            visible: true,
            format
        }
    });
}

function createChart() {
    const $charts = $('.chartTest');
    const columnArray = [];
    columnData.forEach(function(item) {
        columnArray.push(item.title);
    });
    columnArray.splice(0, 1);
    for (let i = 0; i < $charts.length; i += 1) {
        const $chart = $($charts[i]);
        const sparklineName = $chart.attr('chart-name');
        const $sparklineElement = $(`#${sparklineName}`);
        const sparkline = $sparklineElement.data('kendoSparkline') || $sparklineElement.data('kendoDollarValue');
        const chartData = sparkline.options.data || [];
        let chart = {};
        if (sparklineName === 'sparklineConstructionArOver90') chart = sparkLineData.over90;
        if (sparklineName === 'sparklineUnderbillings') chart = sparkLineData.underbillings;
        if (sparklineName === 'sparklineOverbillings') chart = sparkLineData.overbillings;
        if (sparklineName === 'sparklineRetention') chart = sparkLineData.retention;
        if (sparklineName === 'sparklineAmountOfUnapprovedInvoicesInQueue') {
            Object.assign(chartData, sparkLineData.unapprovedAp.data);
            chart = sparkLineData.unapprovedAp;
        }
        initChart($chart, chartData, columnArray, chart.metrics, chart.format);
    }
}

function sparklinesFadeIn(e) {
    // Fired when the chart is ready to render on screen.
    // Render fires twice before and after dataBound
    const { sender } = e;
    const { element } = sender;
    const $el = element.closest('.collapsible--sparkline.--fade-in');
    if ($el.hasClass('--js-data-bound')) $el.addClass('--show');
}
function sparklinesDataBound(e) {
    const { sender } = e;
    const { element } = sender;
    const $el = element.closest('.collapsible--sparkline.--fade-in');
    $el.addClass('--js-data-bound');
}

// Scorecard Sparklines
// =============================================================================

function createSparklines() {
    $('#sparklineConstructionArOver90').kendoSparkline({
        type: 'area',
        chartArea: {
            background: 'transparent'
        },
        data: sparkLineData.over90.data,
        // valueAxis: {
        //     min: 0,
        //     max: 100
        // },
        seriesColors: ['#6698DF'],
        tooltip: {
            visible: true,
            format: '{0} %'
        },
        dataBound: sparklinesDataBound,
        render: sparklinesFadeIn
    });
    $('#sparklineUnderbillings').kendoSparkline({
        data: sparkLineData.underbillings.data,
        chartArea: {
            background: 'transparent'
        },
        type: 'line',
        tooltip: {
            visible: true,
            format: '{0} %'
        },
        dataBound: sparklinesDataBound,
        render: sparklinesFadeIn
    });

    $('#sparklineOverbillings').kendoSparkline({
        chartArea: {
            background: 'transparent'
        },
        type: 'line',
        data: sparkLineData.overbillings.data,
        tooltip: {
            visible: true,
            format: '{0} %'
        },
        dataBound: sparklinesDataBound,
        render: sparklinesFadeIn
    });

    $('#sparklineRetention').kendoSparkline({
        data: sparkLineData.retention.data,
        chartArea: {
            background: 'transparent'
        },
        type: 'area',
        tooltip: {
            visible: true,
            format: '{0} %'
        },
        dataBound: sparklinesDataBound,
        render: sparklinesFadeIn
    });

    $('#sparklineAmountOfUnapprovedInvoicesInQueue').kendoDollarValue({
        data: sparkLineData.unapprovedAp.data,
        metrics: sparkLineData.unapprovedAp.metrics,
        useLast: true,
        autoBind: false,
        dataBound: sparklinesDataBound,
        render: sparklinesFadeIn
    });
}

export default function() {
    _bundle.add({
        name: 'Finance Scorecard: Run Sparklines',
        event: ['on:BundleReady'],
        fn() {
            createSparklines();
        }
    });
    _bundle.add({
        name: 'Finance Scorecard: Run Charts on Scorecard Click',
        event: ['on:PageUpdate'],
        fn() {
            createChart();
        }
    });
    _bundle.add({
        name: 'Finance Scorecard: Charts Resizing',
        event: ['on:ResizeEnd'],
        fn() {
            kendo.resize($('.chart__wrap'));
            kendo.resize($('.sparkline__wrap'));
        }
    });
}
